import { useSiteMetadata, useColorMode } from "@reflexjs/gatsby-theme-core";
import * as React from 'react';
export default {
  useSiteMetadata,
  useColorMode,
  React
};